<template>
    <div class="grid-container mobile-page-padding content-padding">
        <div class="grid-x">
            <div class="food-side-content">
                <page-header title="My orders"></page-header>
            </div>
            <div class="cell large-9 large-offset-3" v-if="isReady">
                <div :class="['grid-x', 'orders-page', 'align-center', {'background-mobile' : orders.length}]">
                    <div class="cell orders-container cards-scroll-container">
                        <div class="grid-x">
                            <div class="order-page-orders" v-if="orders.length">
                                <order-summary
                                    v-for="order in sortedOrders"
                                    :key="order.id"
                                    :order="order"
                                    :is-disabled="!isOpen"
                                >
                                </order-summary>
                            </div>
                            <div v-else-if="loadingOrders" class="text-center cell no-orders-container">
                                <p class="display-2 no-orders-text">Loading your orders</p>
                                <p class="display-large-medium">Please hold on while we fetch your orders...</p>
                            </div>
                            <div v-else class="text-center cell no-orders-container">
                                <img class="no-orders-icon" src="/media/static/svg/no_orders.svg" alt="No orders icon">
                                <p class="display-small color-battleship-gray">Your orders will be kept here</p>
                                <router-link :to="{name: 'food'}" class="button ghost">Make your first order</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators';
import UserModule from '@/stores/modules/user';
import User from '@/models/user';
import Order from '@/models/order';
import PageHeader from '@/components/front/ui/PageHeader.vue';
import OrderSummary from '@/components/front/user/OrderSummary.vue';
import { isStoreOpen } from '@/utils/store-schedule';
import FoodModule from '@/stores/modules/food';

@Component({
    components: { PageHeader, OrderSummary }
})
export default class OrdersPage extends Vue {
    userModule!: UserModule;
    foodModule!: FoodModule;
    isSaveShowed: boolean = false;
    loadingOrders: boolean = true;
    interval: any  = null;
    isOpen: boolean = true;

    created() {
        this.userModule = getModule(UserModule, this.$store);
        this.foodModule = getModule(FoodModule, this.$store);
    }

    async mounted() {
        if (!this.currentUser) {
            this.$router.push({name: 'food'}).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error('Navigation error:', err);
                }
            });
        }
        this.isOpen = await isStoreOpen();
        this.fetchUserOrders();

        if (this.foodModule.orderFlows.length === 0) {
            await this.foodModule.fetchOrderFlows();
        }

        this.interval = setInterval(() => this.refreshActiveOrders(), 60000);
    }

    beforeDestroy() {
        clearInterval(this.interval);
        this.interval = null;
    }

    fetchUserOrders() {
        if (this.currentUser) {
            this.loadingOrders = true;
            this.userModule.fetchUserOrders();
            this.loadingOrders = false;
        }
    }

    refreshActiveOrders() {
        if (this.currentUser) {
            this.userModule.fetchUserActiveOrders();
        }
    }

    get orders() {
        return this.userModule.currentUserOrders;
    }

    get currentUser(): User | null {
        return this.userModule.currentUser;
    }

    get isReady() {
        return this.userModule.currentUser && this.foodModule.orderFlows.length > 0;
    }

    get sortedOrders(): Order[] {
        if (this.userModule.currentUser) return this.orders.sort((a: Order, b: Order) => {
            if (a.id! > b.id!) return -1;
            return 1;
        });
        return [];
    }


}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.order-page-title {
    margin-bottom: 35px;
}

.order-page-orders {
    width: 100%;

    @include breakpoint (small only) {
        padding-left: 20px;
        padding-right: 20px;
    }
}

.save-button {
    @include breakpoint(medium down) {
        position: fixed;
        bottom: 81px;
        left: 0;
        right: 0;
        border-radius: 0px;
        margin: 0;
    }
}

.orders-container {
    @include breakpoint(large) {
        padding-top: 0px;
        padding-right: 40px;
    }
}

.no-orders-container {
    padding-top: 60px;

    .no-orders-icon {
        width: 175px;
        margin-bottom: 15px;

        img {
            width: 100%;
        }
    }

    .no-orders-text {
        margin-bottom: 25px;
    }
}

.orders-page {
    @include breakpoint(medium only) {
        margin-left: -15px;
        margin-right: -15px;
    }
}

</style>

